import './App.css';
import Footer from './components/Footer/Footer';
import Hero from './components/Hero/Hero';
import Programs from './components/Hero/Programs';
import Join from './components/Join/Join';
import Plans from './components/Reasons/Plans';
import { Reasons } from './components/Reasons/Reasons';
import Testimonial from './components/Testimonial/Testimonial';
function App() {
  return (
    <div className="App">
          <Hero/>
          <Programs/>
          <Reasons/>
          <Plans/>
          <Testimonial/>
          <Join/>
          <Footer/>
    </div>
  );
}

export default App;
